import React from 'react';
import { useFlagsmithLoading } from 'flagsmith/react';

import { InitApp } from '../../../initApp';
import { AppLoaderCymbioImage } from './AppLoaderCymbioImage';
import { FILE_SOURCE_NONE } from '../../../constants/featureFlag';

import styles from './AppLoader.module.scss';

export function AppLoader() {
  const { isLoading, source } = useFlagsmithLoading();

  if (isLoading || source === FILE_SOURCE_NONE) {
    return (
      <div className={styles.pageWrapper}>
        <div className={styles.container}>
          <div className={styles.image}>
            <AppLoaderCymbioImage />
          </div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return <InitApp />;
}
